import { inject, observer } from 'mobx-react';
import { Grid, GridColumn } from 'telia-front-react';
import * as React from 'react';
import { Transaction } from '../../../stores/models/Transaction';
import { ITranslateStore } from '../../../stores/TranslateStore';
import TransactionDetailsCard from './TransactionDetailsCard';

interface CorrectionTransactionDetailsProps {
  transaction: Transaction;
  translateStore?: ITranslateStore;
}

@inject('translateStore')
@observer
export default class CorrectionTransactionDetails extends React.Component<CorrectionTransactionDetailsProps> {
  public render(): JSX.Element {
    const { transaction } = this.props;
    const translate = this.props.translateStore.translate;

    return (
      <TransactionDetailsCard>
        <Grid>
          <GridColumn>
            <p className="text-small">{translate('payment-history.receipt-details.description')}</p>
            <p>{translate(`payment-history.correction-transaction.${transaction.externalLabelKey}`)}</p>
          </GridColumn>
        </Grid>
      </TransactionDetailsCard>
    );
  }
}
